import {IHttpService} from "angular";
import {CmaSummary} from "../models/CmaSummary";
import {PortfolioPositions, PortfolioSummary} from "../models/Portfolio";
import {Optional} from "../../js/util/Optional";
import {StringKeyed} from "../../types/GenericTypes";
import {PortfolioMarginRequest} from "../models/PortfolioMarginRequest";
import {PortfolioScenarioResult} from "../models/PortfolioScenarioResult";

export class PortfolioService {

    public static id = "portfolioService";

    /** @ngInject */
    public constructor(private $http: IHttpService) {

    }

    public async portfolios(config?: StringKeyed<any>): Promise<Array<PortfolioSummary>> {
        const response = await this.$http.get<Array<PortfolioSummary>>("/tradefloor/api/client/portfolios", config);
        return response.data!;
    }

    // TODO This needs to be really temporary because it is terrible...
    public async summary(id: number): Promise<Optional<PortfolioSummary>> {
        const summaries = await this.portfolios();
        const summary = summaries.find((s) => s.portfolioId === id);
        return Optional.of(summary);
    }

    public async portfolio(portfolioId: number): Promise<PortfolioPositions> {
        const url = `/tradefloor/api/portfolio/${portfolioId}/positions`;
        const response = await this.$http.get<PortfolioPositions>(url);
        return response.data!;
    }

    public async cmaDetails(portfolioId: number): Promise<CmaSummary | null> {
        const url = `/tradefloor/api/portfolio/${portfolioId}/cma`;
        const response = await this.$http.get(url);
        const summary = Optional.of(response.data)
                                .filter(data => data !== "")
                                .orNull();
        return summary as CmaSummary;
    }

    public async margin(portfolioId: number, request: PortfolioMarginRequest): Promise<PortfolioScenarioResult> {
        const url = `/tradefloor/api/margin/${portfolioId}`;
        const response = await this.$http.post<PortfolioScenarioResult>(url, request);
        return response.data!;
    }
}
